export const MESSAGES = {
  successMessage: "success_message",
  errorMessage: "Ocorreu um erro inesperado. Tente novamente mais tarde!",
};
